import Vue from 'vue';
import Vuex from 'vuex';
import categories from './modules/categories';
import auth from './modules/auth';
import notes from './modules/notes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    categories,
    notes,
    auth,
  },
});
